export enum Diagnostics {
	NOT_IDENTIFIED = 'Not identified',
	SAFE = 'Acceptable',
	INFO = 'Investigate',
	WARNING = 'Investigate and change soon',
	DANGER = 'Investigate and change now'
}

export type NotIdentified = Diagnostics.NOT_IDENTIFIED;
export type Safe = Diagnostics.SAFE;
export type Info = Diagnostics.INFO;
export type Warning = Diagnostics.WARNING;
export type Danger = Diagnostics.DANGER;

export type RebaScores = {
	left: number[];
	right: number[];
};

export type RebaScoreParts = {
	trunk: number[];
	neck: number[];
	left_upper_arm: number[];
	right_upper_arm: number[];
	left_lower_arm: number[];
	right_lower_arm: number[];
	left_knee: number[];
	right_knee: number[];
};

export type AngleNote = {
	angle: number;
	note: number;
};

export type ScoreSides = {
	score_left: number;
	score_right: number;
};

export type RebaScorePerSecond = {
	trunk: Record<number, AngleNote>;
	neck: Record<number, AngleNote>;
	left_upper_arm: Record<number, AngleNote>;
	right_upper_arm: Record<number, AngleNote>;
	left_lower_arm: Record<number, AngleNote>;
	right_lower_arm: Record<number, AngleNote>;
	left_knee: Record<number, AngleNote>;
	right_knee: Record<number, AngleNote>;
	score_seconds: Record<number, ScoreSides>;
};

export type RebaRiskRange = {
	min: number;
	max: number;
	color: string;
};

export type RebaPartsRiskRange = {
	trunk: RebaRiskRange[];
	neck: RebaRiskRange[];
	left_upper_arm: RebaRiskRange[];
	right_upper_arm: RebaRiskRange[];
	left_lower_arm: RebaRiskRange[];
	right_lower_arm: RebaRiskRange[];
	left_knee: RebaRiskRange[];
	right_knee: RebaRiskRange[];
	hip: RebaRiskRange[];
};

export type RebaWorstGrade = {
	worst_grade: number;
	time: string;
	result: number;
};
